import { TFunction } from "i18next";

export const getSlotStatus = (status: string, t: TFunction) => {
  switch (status) {
    case "I":
      return t("slots.status.inactive");
    case "A":
      return t("slots.status.active");
    case "C":
      return t("slots.status.conclued");
    case "F":
      return t("slots.status.confirmed");
    case "P":
      return t("slots.status.planned");
    default:
      return "";
  }
};
